import React, {Component, PropTypes} from 'react';
import Firebase from 'firebase';
import cx from 'classnames';
import ReactSelect from 'react-select';
import SearchInput, {createFilter} from 'react-search-input';
import _ from 'lodash';

export default class Questions extends Component {

  constructor(props) {
    super(props);
    this.state = {
      searchTerm: '',
      lastSearchTerm: ''
    };
  }

  getInitialProps() {
    return {
      categories: []
    };
  }

  searchUpdated(term) {

    const currentSearchTerm = this.state.searchTerm;
    if (term.length > 3) {
      this.setState({searchTerm: term, page: 0, lastSearchTerm: currentSearchTerm});
    } else {
      this.setState({searchTerm: '', page: 0, lastSearchTerm: currentSearchTerm});
    }
  }

  handleAdd() {

    let catId = this.refs.catId.value;
    if(!catId) return;
    let catName = this.refs.catName.value;
    if(!catName) return;

    let cats = this.state.categories;

    const db = Firebase.database();
    db.ref("categories/" + catId).set(catName).then(snapshot => {

      cats.push({
        id:catId,
        name: catName
      });

    }, error => {
      // The Promise was rejected
      console.error(error);
    });

  }

  /*
   *   RENDER METHODS
   */

  render() {

    let DOMAIN = this.props.domain;
    let categs = this.state.categories;

    _.orderBy(categories, 'quiz');

    let categsList = categs.map((cat, index) => {

      return (
        <li key={'cat' + index}>
          <a target="_blank"
             href={'https://console.firebase.google.com/project/' +  DOMAIN + '/database/data/categories/' + cat.id}>{cat.name}</a>&nbsp;
          <span>{cat.quiz}</span>
        </li>
      )
    });

    return (
      <section>
        <h1>All categories / pillars</h1>
        <p>Add a category: <input style={{width: 'auto'}} ref="catId" type="text" name="catId" required placeholder="category id"/> <input ref="catName" type="text" name="catName" required placeholder="category name"/>  <input type="submit" style={{display: 'inline'}} onClick={this.handleAdd.bind(this)}/></p>
        <ul>
          { categsList }
        </ul>
      </section>
    );
  }

  componentWillMount() {
    if (this.props.categories) {
      this.updateStateFromProps(this.props);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.categories) {
      this.updateStateFromProps(nextProps);
    }
  }

  updateStateFromProps(nextProps) {
    this.setState({
      categories: nextProps.categories
    })
  }

}

Questions.propTypes = {
  questions: PropTypes.array
};

